export const createInfographicGenerationRequest = ({
  message,
  currentImage,
  uploadedImage,
  aspectRatio,
}) => {
  return {
    url: "/infographic_generations",
    method: "POST",
    data: {
      message,
      current_image: currentImage || undefined,
      uploaded_image: uploadedImage || undefined,
      aspect_ratio: aspectRatio || "1:1",
    },
    disableLoading: true,
  };
};

export const getInfographicGenerationRequest = (id) => {
  return {
    url: `/infographic_generations/${id}`,
    method: "GET",
    disableLoading: true,
  };
};
